import React, { useState } from 'react';
import './MarketingExecDashboard.scss';
import { ReactComponent as Assign } from '../../assets/assign.svg';
// import { ReactComponent as AssignFilled } from '../../assets/assign.svg';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import base from '../../apis';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { formatNumber } from '../../utils/functions';
import Spinner from '../../components/Spinner/Spinner';
import useFetch from '../../hooks/useFetch';
import { Loader } from '@mantine/core';

const MarketingExecDashboard = () => {
  const marketer_id = useSelector((state) => state.auth?.marketerDetails?.id);
  const name = useSelector((state) => state.auth.first_name);
  const isInternational = useSelector((state) => state.auth.marketerDetails.category === 'international');

  const [isLoading, setIsLoading] = useState(false);
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const [compensation, setCompensation] = useState({
    sum_of_first_compensation: null,
    sum_of_monthly_commision: null,
    first_compensation_count: 0,
    monthly_commision_count: 0,
  });

  useEffect(() => {
    if (!marketer_id) return;
    setIsLoading(true);
    base
      .get(`/compensations/get-compensation-amount/`, {
        params: {
          marketer_id,
        },
      })
      .then(({ data }) => {
        setCompensation(data);
      })
      .catch((err) => {
        toast.error('Could not get compensation');
      })
      .finally(() => {
        setIsLoading(false);
      });

    // return;
    // const urls = [`/operations/marketers/${marketer_id}/offices/`, `/operations/marketers/${marketer_id}/tasks/`];

    // Promise.all(urls.map((endpoint) => base.get(endpoint)))
    //   .then((data) => {
    //     const offices = data[0].data.map((item) => ({ ...item, type: 'office' }));
    //     const tasks = data[1].data.map((item) => ({ ...item, type: 'task' }));
    //     const first = tasks.filter((item) => item.reassigned);
    //     const second = [
    //       ...tasks.filter((item) => !['DC', 'CC'].includes(item.call_status) && !item.reassigned),
    //       ...offices,
    //     ];
    //     const third = [...tasks.filter((item) => ['DC', 'CC'].includes(item.call_status) && !item.reassigned)];
    //     setData([first, second, third]);
    //   })
    //   .catch((err) => {
    //     toast.error('Could not get tasks and offices');
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    //   });
  }, [marketer_id]);

  let date = new Date();
  let currentMonth = new Date().toLocaleString('en', { month: 'long' });
  let currentDay = days[date.getDay()];
  let currentDate = date.getDate();
  return (
    <>
      {isLoading && <Spinner />}
      <div className="exec_dashboard">
        <div className="exec_dashboard_wrapper">
          <div className="dashboard_header">
            <p className="header_date">
              {currentDay}, {currentMonth} {currentDate}
            </p>
            <p className="greetings">Good day, {name}</p>
          </div>
          <div className="month_date">
            <p>{currentMonth}</p>
          </div>
          <div className="agent_subscription_cards">
            <NavLink to="/compensation" className="subscription_card">
              <div className="subscription_card_wrapper">
                <p className="subscription_orders">
                  <span className="subscription_number">{compensation?.first_compensation_count}&nbsp;</span>
                  <span>Subscription Order(s)</span>
                </p>
                <p className="total_earnings">Total Earning</p>
                <p className="total_earned">$ {formatNumber(compensation?.sum_of_first_compensation || 0)}</p>
                {/* <hr /> */}
                {/* <p className='per_subscription_order'>
								<span className='subscription_order_number'>$200.00</span>
								<br />
								<span className='subscription_order_text'>
									per Subscription order
								</span>
							</p>
							<p className='subscription_info'>
								Paid after 1st Monthly payment is received.
							</p> */}
              </div>
            </NavLink>
            <NavLink to="/compensation" className="subscription_card">
              <div className="subscription_card_wrapper">
                <p className="subscription_orders">
                  <span className="subscription_number">{compensation?.monthly_commision_count}&nbsp;</span>
                  <span>Active Subscriptions {isInternational ? '+ Appointment Commission' : ''}</span>
                </p>
                <p className="total_earnings">Total Earning</p>
                <p className="total_earned">$ {formatNumber(compensation?.sum_of_monthly_commision || 0)}</p>
                {/* <hr /> */}
                {/* <p className='per_subscription_order'>
								<span className='subscription_order_number'>$ 20.00</span>
								<br />
								<span className='subscription_order_text'>
									Monthly residual for active Subscriptions
								</span>
							</p> */}
                {/* <p className='subscription_info'></p> */}
              </div>
            </NavLink>
            {/* <NavLink to="/compensation" className="subscription_card">
              <div className="subscription_card_wrapper">
                <p className="subscription_orders">
                  <span className="subscription_number">0 &nbsp;</span>
                  <span>Decades of Monthly Subscriptions</span>
                </p>
                <p className="total_earnings">Total Earning</p>
                <p className="total_earned">$ 0.00</p>
                <hr /> */}
            {/* <p className='per_subscription_order'>
								<span className='subscription_order_number'>$ 300.00</span>
								<br />
								<span className='subscription_order_text'>
									additional bonus per 10 Subcriptions monthly
								</span>
							</p> */}
            {/* <p className='subscription_info'></p> */}
            {/* </div>
            </NavLink> */}
          </div>
          {/* <div className="team_session">
            <div className="team_session_card1">
              <div className="divide">
                <p className="my_team">My Team:</p>
              </div>
              <div className="divide">
                <div>
                  <p className="grey_text">My position</p>
                  <p className="strong_blue">
                    2 &nbsp;<span>ND</span>
                  </p>
                </div>
              </div>
              <div className="divide">
                <div>
                  <p className="grey_text">Value</p>
                  <p className="strong_blue">
                    <span>$&nbsp;</span>
                    300
                  </p>
                </div>
              </div>
            </div>
            <div className="team_session_card2">
              <div className="divide">
                <p className="my_team">My Team Bonus:</p>
              </div>
              <div className="divide">
                <div>
                  <p className="grey_text">My % share</p>
                  <p className="strong_blue">
                    12.5 <span>&nbsp;%</span>
                  </p>
                </div>
              </div>
              <div className="divide">
                <div>
                  <p className="grey_text">Value</p>
                  <p className="strong_blue">
                    <span>$ &nbsp;</span>
                    145.89
                  </p>
                </div>
              </div>
            </div>
          </div> */}
          <MyOverview />

          {/* <div className="assigned_section">
            <div className="recently_assigned">
              <div className="recently_assigned_title">
                <p className="recently_asssigned">Recently assigned</p>
              </div>
              {data[0]?.map((office) => (
                <div className="office_details" key={office.id}>
                  <div className="office_details_content">
                    <p>
                      <span className="card_title">Office</span>
                      <br />
                      <span className="card_info">{office.agent_first_name}</span>
                    </p>
                  </div>
                  <div className="office_details_content">
                    <p>
                      <span className="card_title">{office.location}</span>
                      <br />
                      <span className="card_info">
                        {office.office.city}, County, {office.office.state}, {office.zip_code}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="agents_cards_column">
              <div className="completed_wrapper">
                <p>Completed</p>
                <p className="total_completed">{data[2]?.length}</p>
              </div>
              <div className="agent_cards_wrapper">
                {data[2]?.map((office) => (
                  <div className="agent_card" key={office.id}>
                    <p className="agent_name">{office.office.manager_name}</p>
                    <p className="location">{office.office.location}</p>
                    <p>
                      <span className="call_status">Call Status</span>
                      <br />
                      <span className="interest">{getCallStatus(office.call_status)}</span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default MarketingExecDashboard;

const MyOverview = () => {
  const marketer_id = useSelector((state) => state.auth?.marketerDetails?.id);
  const { data: officeCount, isLoading } = useFetch(`/operations/marketers/${marketer_id}/offices/`);
  if (isLoading)
    return (
      <div className="brief_bpo_info">
        {' '}
        <Loader />
      </div>
    );
  return (
    <div className="brief_bpo_info">
      <p>Overview</p>
      <div className="vertical_rule" />
      <p>
        <Assign className="brief_bpo_info_icon" />
        <span>{officeCount?.length || 0}</span>
        <span>Office(s) Assigned</span>
      </p>
      {/* <p>
              <AssignFilled className="brief_bpo_info_icon" />
              <span>{data[2]?.length} </span>
              <span>Task Completed</span>
            </p> */}
    </div>
  );
};
